module.exports = "<div *ngIf=\"alternative\" class=\"subproduct-item\" (click)=\"onSelected($event, alternativeIndex, productGroup, product)\">\r\n    <div class=\"product-spinner\" [class.hide]=\"!isLoadingShow\">\r\n        <img src=\"assets/img/25.gif\" />\r\n    </div>\r\n\r\n    <div class=\"subproduct-image\" [class.selected]=\"productGroup.getAltNumber() == alternativeIndex\">\r\n        <img class=\"product-img\" style=\"opacity: 0\" src=\"\" />\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/subproduct_alternative.component.html
// module id = 564
// module chunks = 1